import dayjs from 'dayjs'

// The backend masks a book/user by returning this sentinel in place of the name.
export const MASKED_NAME = '*****'

export interface BookIdeaLinkInput {
  userId?: string | null
  userName?: string | null
  bookStatus?: string | null
  canSeeBookDetail?: boolean | null
  groupByFirm?: boolean
  startDate?: string | null
  endDate?: string | null
}

export interface BookIdeaLink {
  href?: string
  isInactive: boolean
}

const toDateParam = (value?: string | null): string => {
  if (!value) return ''
  const date = dayjs(value)
  return date.isValid() ? date.format('YYYY-MM-DD') : ''
}

// Single source of truth for whether a book name opens the idea list, shared by
// the ranking/statistics grids and the ranking cards.
export function getBookIdeaLink({
  userId,
  userName,
  bookStatus,
  canSeeBookDetail,
  groupByFirm = false,
  startDate,
  endDate,
}: BookIdeaLinkInput): BookIdeaLink {
  const isMasked = userName === MASKED_NAME
  const isInactive = !groupByFirm && !isMasked && bookStatus === 'Inactive'
  if (groupByFirm || isMasked || isInactive || !userId || !canSeeBookDetail)
    return { isInactive }

  return {
    href: `/idea?userId=${encodeURIComponent(userId)}&startDate=${encodeURIComponent(
      toDateParam(startDate)
    )}&endDate=${encodeURIComponent(toDateParam(endDate))}`,
    isInactive,
  }
}
